import React from 'react';
import {
  Flex,
  Heading,
  Button,
  Box,
  Text,
  Badge,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaSync } from 'react-icons/fa';
import { OktonReactTable as Table } from '@okton/platform-ui/react-table';

import Page from '../../layout/IntegraAppPage';

type FilaItem = {
  tipo: string;
  status: string;
  prioridade: string;
  tentativas: string;
  executarEm: string;
  criadoEm: string;
};

type FilaRow = { row: { original: FilaItem } };

const statusColorMap: Record<string, string> = {
  Pendente: 'yellow',
  Processando: 'gray',
  Concluído: 'green',
  Erro: 'red',
};

const Fila = () => {
  const bgPage = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('black', 'white');

  const filaData = [
    {
      tipo: 'sincronização produto',
      status: 'Pendente',
      prioridade: '5',
      tentativas: '0/3',
      executarEm: '23/03/2026, 17:33:31',
      criadoEm: '23/03/2026, 17:18:31',
    },
    {
      tipo: 'importação pedido',
      status: 'Processando',
      prioridade: '8',
      tentativas: '1/3',
      executarEm: '23/03/2026, 17:28:31',
      criadoEm: '23/03/2026, 17:13:31',
    },
    {
      tipo: 'atualização estoque',
      status: 'Concluído',
      prioridade: '7',
      tentativas: '1/3',
      executarEm: '23/03/2026, 17:18:31',
      criadoEm: '23/03/2026, 17:08:31',
    },
    {
      tipo: 'sincronização preço',
      status: 'Erro',
      prioridade: '5',
      tentativas: '3/3',
      executarEm: '23/03/2026, 16:58:31',
      criadoEm: '23/03/2026, 16:28:31',
    },
  ];

  const colunasFila = React.useMemo(
    () => [
      {
        Header: 'TIPO',
        accessor: 'tipo',
        Cell: ({ row }: FilaRow) => (
          <Badge colorScheme="blue" fontSize="12px" borderRadius="lg">
            {row.original.tipo}
          </Badge>
        ),
      },
      {
        Header: 'STATUS',
        accessor: 'status',
        Cell: ({ row }: FilaRow) => {
          return (
            <Badge
              colorScheme={statusColorMap[row.original.status]}
              borderRadius="lg"
            >
              {row.original.status}
            </Badge>
          );
        },
      },
      {
        Header: 'PRIORIDADE',
        accessor: 'prioridade',
        Cell: ({ row }: FilaRow) => (
          <Text fontWeight="bold">{row.original.prioridade}</Text>
        ),
      },
      {
        Header: 'TENTATIVAS',
        accessor: 'tentativas',
      },
      {
        Header: 'EXECUTAR EM',
        accessor: 'executarEm',
      },
      {
        Header: 'CRIADO EM',
        accessor: 'criadoEm',
      },
    ],
    [],
  );

  return (
    <Page>
      <Flex justify="space-between" align="center" p={3}>
        <Heading fontWeight="bold" fontSize={25}>
          Fila
        </Heading>

        <Button fontSize="15px" colorScheme="blue" leftIcon={<FaSync />}>
          Atualizar
        </Button>
      </Flex>

      <Box bg={bgPage} borderWidth="1px" borderRadius="md" p={4}>
        <Heading size="md" mb={1} color={textColor}>
          Fila de processamento
        </Heading>

        <Text fontSize="sm" color="gray.500" mb={4}>
          Tarefas agendadas e em execução
        </Text>

        <Table columns={colunasFila} data={filaData} />
      </Box>
    </Page>
  );
};
export default Fila;
